<script setup lang="ts">
import {useContext, useLocalization, useOrderViewContext} from '@hantera/portal-app';
import {ref, watch} from 'vue';
import {ElasticInput} from "@hantera/design-system";

const orderViewContext = useOrderViewContext();
const t = useLocalization('components.order.notes');
const context = useContext();

const notes = ref(orderViewContext.state.notes ?? '');
watch(() => orderViewContext.state.notes, (val) => {
  notes.value = val ?? '';
});

watch(() => notes.value, async () => {
  if (notes.value?.trim() === orderViewContext.state.notes?.trim()) {
    return
  }

  await orderViewContext.pushPendingChange(
    'notes',
    [{
      type: 'setNotes',
      value: notes.value?.trim() ?? '',
    }],
    "Set order notes to '{notes}'",
    {
      notes: notes.value,
    }
  );
})

</script>

<template>
  <div>
    <div class="box-content-label">
      {{t('label')}}
    </div>
    <ElasticInput
      v-model.lazy="notes"
      :placeholder="t('placeholder')"
      class="box-pop"
    />
  </div>
</template>

<style scoped>

</style>